<kendo-pdfviewer
  [tools]="tools"
  [url]="fromRule ? rule.administrativeRule?.url : fileUrl"
  [saveFileName]="'normas_' + getStudentName()"
>
</kendo-pdfviewer>
